import { render, staticRenderFns } from "./state_data.vue?vue&type=template&id=ffadbe42&"
import script from "./state_data.vue?vue&type=script&lang=js&"
export * from "./state_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports